import { AddedAttribute, AddedAttributeType } from 'pages/UserPage/components/MiddlePane/types';
import { clone } from 'common/utils/generic';
import { isEquivalentAttribute } from 'pages/UserPage/components/MiddlePane/utils/displayAttributes';
import { message } from 'antd';
import { SetUserAttributeTypes } from '../../../../updateAttributeValueUtils';

/**
 * Updates the is_secondary attribute of an attribute.
 */
export const updateAttributeSecondary = (
  attributeTypeName: string,
  params: { is_secondary: boolean }, // can add more in the future.
  value: AddedAttribute,
  userAttributeTypes: AddedAttributeType[],
  setUserAttributeTypes: SetUserAttributeTypes
) => {
  const userAttributeTypesCopy = clone(userAttributeTypes);
  const attributeType = userAttributeTypesCopy.find(type => type.name === attributeTypeName);
  const attribute = attributeType?.attributes.find(attr => isEquivalentAttribute(attr, value));
  if (!attribute) {
    // this shouldn't happen
    message.error('Could not find attribute to edit params');
  } else {
    attribute.is_secondary = params.is_secondary;
    setUserAttributeTypes(userAttributeTypesCopy);
  }
};

